import React from 'react';
import sectors from '../data/sectors';
import './Sectors.css';

const icons = {
  datacenter: (
    <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 32 32">
      <rect x="4" y="10" width="24" height="18" rx="1"/>
      <path d="M4 14h24M12 10V6h8v4"/>
      <rect x="10" y="18" width="12" height="10"/>
    </svg>
  ),
  office: (
    <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 32 32">
      <path d="M6 28V10L16 4l10 6v18"/>
      <rect x="12" y="18" width="8" height="10"/>
      <path d="M12 18v-4h8v4"/>
    </svg>
  ),
  industrial: (
    <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 32 32">
      <rect x="2" y="12" width="28" height="16"/>
      <path d="M6 12V8h20v4M2 20h28"/>
      <rect x="8" y="20" width="6" height="8"/>
      <rect x="18" y="20" width="6" height="8"/>
    </svg>
  ),
  healthcare: (
    <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 32 32">
      <path d="M16 4l12 8v16H4V12L16 4z"/>
      <rect x="11" y="18" width="10" height="10"/>
      <circle cx="16" cy="12" r="3"/>
    </svg>
  ),
};

export default function Sectors() {
  return (
    <section id="sectors" className="sectors-section">
      <div className="section-inner">
        <div className="section-label">Who We Serve</div>
        <h2>Facility Sectors</h2>
        <p className="section-sub">
          We serve a range of commercial and critical facility types where building
          intelligence is mission-critical.
        </p>
        <div className="sectors-grid">
          {sectors.map((sector) => (
            <div key={sector.id} className="sector-chip">
              <div className="sector-icon">{icons[sector.icon]}</div>
              <p>{sector.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
